export const ALL_VACANCIES_REQUEST = 'ALL_VACANCIES_REQUEST';
export const ALL_VACANCIES_RECIEVE = 'ALL_VACANCIES_RECIEVE';
export const SHARE_CANDIDATE_REQUEST = 'SHARE_CANDIDATE_REQUEST';
